import React, { Component } from 'react'

import { motion } from 'framer-motion';
import Header from '../components/Header';
import { fadeIn } from '../variants';
export default class Privacy extends Component {
  render() {
    return (
        <div className='bg-site bg-no-repeat bg-cover overflow-hidden'>
        <Header />
        <div className="container mx-auto">
            <div className="text-center">
                <motion.h1 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                className='text-accent text-[40px] mb-6 font-bold'
                >
                    Terms of service & Privacy Policy
                </motion.h1>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}}  c
                lassName="text-accent font-bold">
                    Privacy Policy of [RO] Trans Express
                </motion.p>
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    [RO] Trans Express operates the www.rotransexpress.ro website, which provides the SERVICE.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the [RO] Trans Express website.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. The Personal Information that we collect are used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at [RO] Trans Express, unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the Privacy Policy Template.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}}  
                className="text-accent font-bold">Information Collection and Use</motion.p>
               <motion.p variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} >
                     For a better experience while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.
                
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}}  
                className="text-accent font-bold"
                >
                Log Data</motion.p>
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer’s Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}}  
                className="text-accent font-bold"
                >
                    Cookies
                </motion.p>
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer’s hard drive.
                </motion.p>
                
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.
                </motion.p>
                

                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}}  
                className="text-accent font-bold"
                >
                    Service Providers
                </motion.p>
                <motion.p 
                variants={fadeIn('down', 0.2)} 
                initial="hidden" whileInView={'show'} 
                viewport={{once: false, amount: 0.4}} 
                >
                    We may employ third-party companies and individuals due to the following reasons:
                </motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >To facilitate our Service;</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >To provide the Service on our behalf;</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >To perform Service-related services; or</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >To assist us in analyzing how our Service is used.</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}}  className="text-accent font-bold">Security</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}}  className="text-accent font-bold">Links to Other Sites</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}}  className="text-accent font-bold">Children’s Privacy</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >Changes to This Privacy Policy</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}}  className="text-accent font-bold">Contact Us</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >
                admin@rotransexpress.ro <br/>
                <i>[RO] Trans Express</i>
            </motion.p>
                
                
                <br />
                <motion.p 
                variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}}  
            className="text-accent font-bold">GDPR Data protection rights</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service. </motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</motion.p> 
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions. If you make a request, we have one month to respond to you.</motion.p>
                
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >If you would like to exercise any of these rights, please contact us.</motion.p>
                <motion.p variants={fadeIn('down', 0.2)} 
            initial="hidden" whileInView={'show'} 
            viewport={{once: false, amount: 0.4}} >admin@rotransexpress.ro</motion.p>
            </div>
        </div>
        <div className='h-[10vh]'></div>
      </div>
    )
  }
}
